import { ArrowLeft, ChevronRight, LogOut, Settings, User } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MobileLayout } from "../components/layout/MobileLayout.jsx";
import { Button } from "../components/ui/Button.jsx";
import { Card, CardContent } from "../components/ui/Card.jsx";
import { getCurrentUser, removeAuthToken } from "../services/authService.js";

export default function Account() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    (async () => {
      const res = await getCurrentUser();
      if (res.success) setUser(res.user);
    })();
  }, []);

  const handleLogout = () => {
    removeAuthToken();
    navigate("/");
  };

  const menuItems = [
    {
      icon: User,
      label: "Profile",
      desc: "View and edit your profile",
      onClick: () => navigate("/profile"),
    },
    {
      icon: Settings,
      label: "Settings",
      desc: "Custom fields, lead stages, webhook",
      onClick: () => navigate("/settings"),
      adminOnly: true,
    },
  ];

  const filteredItems = menuItems.filter(
    (item) => !item.adminOnly || user?.user_role === "business_admin"
  );

  return (
    <MobileLayout showNavigation={true}>
      <div className="p-4 space-y-4">
        {/* Header */}
        <div className="flex items-center gap-3">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate(-1)}
            className="rounded-full"
          >
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <h1 className="text-lg font-bold">Account</h1>
        </div>

        {/* Menu Items */}
        <Card className="border-2 shadow-sm border-blue-100/50 rounded-xl overflow-hidden">
          <CardContent className="p-0">
            {filteredItems.map((item, idx) => (
              <button
                key={idx}
                onClick={item.onClick}
                className="w-full flex items-center justify-between p-3.5 hover:bg-gray-50 transition-colors border-b border-gray-50 last:border-0"
              >
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-lg bg-gray-100 flex items-center justify-center">
                    <item.icon size={16} className="text-gray-600" />
                  </div>
                  <div className="text-left">
                    <p className="text-sm font-medium text-gray-800">{item.label}</p>
                    <p className="text-[10px] text-gray-400">{item.desc}</p>
                  </div>
                </div>
                <ChevronRight size={16} className="text-gray-300" />
              </button>
            ))}
          </CardContent>
        </Card>

        {/* Logout */}
        <Card className="border-2 shadow-sm border-red-100/50 rounded-xl overflow-hidden">
          <CardContent className="p-0">
            <button
              onClick={handleLogout}
              className="w-full flex items-center gap-3 p-3.5 hover:bg-red-50 transition-colors"
            >
              <div className="w-8 h-8 rounded-lg bg-red-50 flex items-center justify-center">
                <LogOut size={16} className="text-red-500" />
              </div>
              <p className="text-sm font-medium text-red-500">Logout</p>
            </button>
          </CardContent>
        </Card>
      </div>
    </MobileLayout>
  );
}
